import { Controller } from "@hotwired/stimulus"

// Stimulus controller for billable fields toggle visibility and rate calculations
// Issue #865 - Epic #788 Track A
//
// Provides:
// - Dynamic show/hide of billable fields based on checkbox state
// - Automatic fully burdened rate calculation
// - Client-side validation for negative rates
//
// Usage in view:
//   <div data-controller="billable-toggle">
//     <input type="checkbox" data-billable-toggle-target="checkbox" data-action="change->billable-toggle#toggle">
//     <div id="billable_fields" data-billable-toggle-target="fields">
//       <input data-billable-toggle-target="maxBillRate" data-action="input->billable-toggle#calculate blur->billable-toggle#validateRate">
//       <input data-billable-toggle-target="burdenRate" data-action="input->billable-toggle#calculate">
//       <span id="fully_burdened_rate" data-billable-toggle-target="fullyBurdened"></span>
//     </div>
//   </div>
//
export default class extends Controller {
  static targets = ["fields", "checkbox", "maxBillRate", "burdenRate", "fullyBurdened", "validationMessage"]

  connect() {
    // Apply initial visibility state on page load
    this.toggle()
    // Calculate initial value if fields have values
    this.calculate()
  }

  // Toggle visibility of billable fields based on checkbox state
  toggle() {
    if (this.hasCheckboxTarget && this.hasFieldsTarget) {
      // #billable_fields renders with .d-none; show it only when checked.
      this.fieldsTarget.classList.toggle("d-none", !this.checkboxTarget.checked)
    }
  }

  // Calculate fully burdened rate: maxBillRate * (1 + burdenRate / 100)
  calculate() {
    if (!this.hasMaxBillRateTarget || !this.hasFullyBurdenedTarget) {
      return
    }

    const maxRate = parseFloat(this.maxBillRateTarget.value) || 0
    const burdenRate = this.hasBurdenRateTarget ? (parseFloat(this.burdenRateTarget.value) || 0) : 0

    // Formula: maxBillRate * (1 + burdenRatePercentage / 100)
    const fullyBurdened = maxRate * (1 + burdenRate / 100)

    // Display with 2 decimal places
    this.fullyBurdenedTarget.textContent = fullyBurdened.toFixed(2)
  }

  // Validate that rate is non-negative and show feedback
  validateRate(event) {
    const value = parseFloat(event.target.value)
    const feedbackElement = this.findValidationFeedback(event.target)

    if (value < 0) {
      event.target.classList.add("is-invalid")
      if (feedbackElement) {
        feedbackElement.textContent = "Bill rate must be non-negative"
        feedbackElement.style.display = "block"
      }
    } else {
      event.target.classList.remove("is-invalid")
      if (feedbackElement) {
        feedbackElement.style.display = "none"
      }
    }
  }

  // Find the validation feedback element associated with an input
  findValidationFeedback(input) {
    // Look for sibling .invalid-feedback element
    const parent = input.parentElement
    if (parent) {
      return parent.querySelector(".invalid-feedback")
    }
    return null
  }
}
